import { render, staticRenderFns } from "./SolicitudesDadoDeBajaListado.vue?vue&type=template&id=92281506"
import script from "./SolicitudesDadoDeBajaListado.vue?vue&type=script&lang=js"
export * from "./SolicitudesDadoDeBajaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports